import { useEffect, useState } from 'react'
import { useLocation } from 'react-router'
import { ROUTES } from '@/constants'
import { useStores } from '@/stores'

export const useAuthBootstrap = () => {
  const { authStore, profileStore, gamificationOfferStore, appStore, formSubmissionStore } = useStores()
  const [isInitiated, setInitiatedStatus] = useState(true)
  const location = useLocation()

  const getUserData = async () => {
    try {
      await profileStore.getProfile()
      await gamificationOfferStore.getGamificationOffer()
      await appStore.getNotificationsCount()
    } catch (error: Error | unknown) {
      console.error(error)
    } finally {
      setInitiatedStatus(false)
    }
  }

  const checkFormSubmission = async () => {
    try {
      await formSubmissionStore.getAvailableFormSubmission()
      if (formSubmissionStore.availableFormSubmission) {
        formSubmissionStore.setShowSubmissionStartModal(true)
      }
    } catch (error: Error | unknown) {
      console.error(error)
    }
  }

  useEffect(() => {
    if (authStore.isAuth) {
      getUserData()
    }
  }, [location.pathname])

  useEffect(() => {
    if (location.pathname === ROUTES.home || location.pathname.includes('lesson')) {
      checkFormSubmission()
    }
  }, [location.pathname])

  return [isInitiated]
}
